import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import BackBtn from "../components/BackBtn";
import VehicleImage from "../components/VehImage";
import VehicleStatus from "../components/VehStatus";
import Ammunition from "../components/Ammunition";
import VehicleFeatures from "../components/VehFeatures";
import { VehicleInformation } from "../data/VehInfo";
import './VehOperation.css';
// import {useTestOp} from "../tests/TestOp.js"
import InputWidget from "../tests/TestInputWindow.jsx"

import { useSelectedVehicle } from "../context/vehicle.context";

const VehicleOperation = () => {
    
    const { selVehData } = useSelectedVehicle();
    const navigate = useNavigate();
    // const test = useTestOp();

    // Auto-redirect if no vehicle selected
    useEffect(() => {
        // test.testMobilityKill();
        if (!selVehData?.vehKey) {
            navigate("/vehicle-select");
        }
    }, [selVehData, navigate]);

    if (!selVehData?.vehKey) {
        return null; // prevent rendering until redirect
    }

    

    const variantData = VehicleInformation().getById(selVehData.vehKey).variants[selVehData.variantKey];
    //   const [data, setData] = useState(vehData);

    return (
        <div className="page vehOperationsPage">
            {/* <h2 className="page-title">{variantData.title ?? selVehData.vehKey} - {selVehData.variantKey}</h2> */}
            <h4 className="page-title">{variantData.description ? variantData.description : `${selVehData.vehKey} - ${selVehData.variantKey}`}</h4>
            <BackBtn url="/vehicle-select" description="Select Vehicle" />
            <div className="vehicle-operation-top pageLightMode">
                <Ammunition ammunition={variantData.ammunition} />
                <VehicleStatus />
                <VehicleFeatures features={selVehData.features} />
            </div>
            <VehicleImage {...variantData} />

            <InputWidget/>
        </div>
    );
};

export default VehicleOperation;